import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new Event("cq:unauthorized"));
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message === "Network Error" ? "Network error. Check your connection." : "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function pollJob(path, { interval = 2500, timeout = 240000 } = {}) {
  const start = Date.now();
  while (Date.now() - start < timeout) {
    const { data } = await api.get(path);
    if (data.status === "done") return data.result;
    if (data.status === "failed") throw new Error(data.error || "The AI engine could not complete this request.");
    await new Promise((r) => setTimeout(r, interval));
  }
  throw new Error("This is taking longer than expected. Please try again.");
}

export const fmtDate = (iso, opts = { month: "short", day: "numeric" }) => {
  if (!iso) return "—";
  const d = iso.length === 10 ? new Date(`${iso}T12:00:00`) : new Date(iso);
  return d.toLocaleDateString(undefined, opts);
};
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const humanize = (s) => (s || "").replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
export const safeNext = (n) => (n && n.startsWith("/") && !n.startsWith("//") ? n : null);
export const nextFrom = (search) => safeNext(new URLSearchParams(search).get("next"));

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function downloadFile(path, fallbackName) {
  let r;
  try { r = await api.get(path, { responseType: "blob" }); } catch (e) {
    if (e.response?.data instanceof Blob) { try { e.response.data = JSON.parse(await e.response.data.text()); } catch { /* not JSON */ } }
    throw e;
  }
  const m = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "");
  saveBlob(r.data, m ? m[1] : fallbackName);
}
